export const atlasVertexShader = `
    varying vec2 vUv; varying vec3 vNormal;
    void main() {
        vUv = uv; vNormal = normalize(normalMatrix * normal);
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const atlasFragmentShader = `
    uniform sampler2D atlasTexture; uniform float minU; uniform float minV;
    uniform float atlasScaleU; uniform float atlasScaleV;
    varying vec2 vUv; varying vec3 vNormal;
    void main() {
        vec2 atlasUV;
        atlasUV.x = (vUv.x - minU) / atlasScaleU;
        atlasUV.y = 1.0 - (vUv.y - minV) / atlasScaleV;
        vec4 color = texture2D(atlasTexture, atlasUV);
        float lighting = max(0.3, dot(vNormal, normalize(vec3(1.0, 1.0, 1.0))));
        color.rgb *= lighting;
        gl_FragColor = color;
    }
`;
